import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table bets report view.
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            view: 'treetable', // Treetable view
            id: 'treetable', // ID of the treetable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable selection
            scheme: {
                $group: {
                    by: 'UserName', // Grouping by UserName
                    map: {
                        UserName: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                        Amount: ['Amount', 'sum'], // Summing Amount
                        WinningAmount: ['WinningAmount', 'sum'], // Summing WinningAmount
                        Tax: ['Tax', 'sum'], // Summing Tax
                        WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Summing WinningAmountTotal
                    },
                },
            },
            columns: [
                {
                    id: 'UserName', // Column ID
                    header: 'UserName', // Column header
                    width: 200, // Column width
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Return group template
                        return obj.UserName; // Return UserName
                    },
                    footer: 'Total:', // Footer content
                },
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Detalles', // Tooltip text
                    template: function (obj) {
                        if (obj.$level == 1) {
                            return ''; // No details for level 1
                        } else {
                            if (obj.$level == 2) {
                                return "<span class='webix_icon wxi-close details'></span>"; // Details icon for level 2
                            }
                        }
                    },
                },
                { id: 'Id', header: 'Ticket Id', width: 100, sort: 'int' }, // Ticket Id column
                { id: 'UserId', header: 'Usuario', width: 100, sort: 'int' }, // User Id column
                {
                    id: 'State', // Column ID
                    header: 'Estado', // Column header
                    options: [
                        // State options
                        { id: '', value: 'None' },
                        { id: 'A', value: 'Abierto' },
                        { id: 'C', value: 'Cancelado' },
                        { id: 'I', value: 'Cerrado' },
                    ],
                },
                { id: 'Date', header: 'Fecha', width: 150, sort: 'int' }, // Date column
                {
                    id: 'Amount', // Column ID
                    header: 'Valor ', // Column header
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                {
                    id: 'WinningAmount', // Column ID
                    header: 'Premios ', // Column header
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                {
                    id: 'Tax', // Column ID
                    header: _('Impuesto'), // Column header (localized)
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                {
                    id: 'WinningAmountTotal', // Column ID
                    header: _('Premio Total'), // Column header (localized)
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                { id: 'Odds', header: 'Odds', width: 100, sort: 'int' }, // Odds column
                { id: 'UserIP', header: 'IP', width: 120, sort: 'int' }, // User IP column
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get item by ID
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            footer: true, // Enable footer
            math: true, // Enable math calculations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'null/Report/GetBetHistory?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the grid with event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // Grid data URL
        var filter = ''; // Initialize filter string

        // Event listener for filtering bets report
        this.on(this.app, 'betsReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'end') {
                                    var d = new Date(object2[j][1]); // Create date object for end
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MaxCreatedLocal to filter
                                } else {
                                    if (object2[j][0] === 'start') {
                                        var d = new Date(object2[j][1]); // Create date object for start
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MinCreatedLocal to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get item by ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
